let ADS_LOADING = 'ADS_LOADING';

export default { ADS_LOADING };
